import React from 'react'

export const MyMBase64Image = ({ encodeData, fileExtension, alt, ...other }) => {
  return (
    <img src={`data:image/${fileExtension};base64,${encodeData}`} alt={alt} {...other} />
  )
}
